(function () {
  'use strict';

  angular.module('ringbaPortal').component('payoutSettings', {
    bindings: {
      defaultPayoutSettings: '<',
      readOnly: '<',
      onUpdate: '&'
    },
    controller: PayoutSettingsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/payout-settings/payout-settings.view.html'
  });

  function PayoutSettingsController(
    infoService,
    affiliateService,
    payoutService,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.regex_digits_optional = new RegExp('\\d*');
    vm.conversionSettings = [];
    vm.timeZones = [];
    vm.setPayoutHours = false;
    vm.showCaps = false;
    vm.oldValue = {};

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.onPayoutHoursChange = onPayoutHoursChange;
    vm.toggleValueChanged = toggleValueChanged;
    vm.inputChange = inputChange;
    vm.handleLimitPayoutChange = handleLimitPayoutChange;
    vm.payoutSettingChange = payoutSettingChange;
    vm.onCapToggleChange = onCapToggleChange;
    vm.onConversionTypeChange = onConversionTypeChange;
    vm.onRevShareRangeToggle = onRevShareRangeToggle;
    vm.toggleSetHours = toggleSetHours;

    function onChanges(changesObj) {
      if (changesObj.defaultPayoutSettings) {
        vm.payoutSettingsObject = vm.defaultPayoutSettings || {isRevShare: false};
        vm.payoutCaps = affiliateService.initializePayoutCaps(vm.payoutSettingsObject);
        _setShowCaps();
        _sanitizePayout();
      }
      if (changesObj.defaultPayoutSettings.isFirstChange()) {
        payoutSettingChange();
      }
    }

    function onInit() {
      _loadConversionSettings();
      _loadTimeZones();
      _initSetHours();
    }

    function onConversionTypeChange() {
      if ('callLength' === vm.payoutSettingsObject.payoutConversionType && !vm.payoutSettingsObject.isRevShare) {
        vm.payoutSettingsObject.payoutConversionArgs = vm.payoutSettingsObject.payoutConversionArgs || {};
        vm.payoutSettingsObject.payoutConversionArgs.startTimerEvent = vm.payoutSettingsObject.payoutConversionArgs.startTimerEvent || 'OnConnectedCall';
      }

      payoutSettingChange();
    }

    function payoutSettingChange() {
      if (vm.onUpdate) {
        affiliateService.resetCallCaps(vm.payoutCaps, vm.payoutSettingsObject);
        vm.onUpdate({
          $event: {
            payoutSettings: vm.payoutSettingsObject
          }
        });
      }
    }

    function onCapToggleChange(enabled, capType) {
      vm.payoutSettingsObject[capType] = (enabled === 1) ? undefined : -1;
      vm.onUpdate({
        $event: {
          payoutSettings: vm.payoutSettingsObject
        }
      });
    }

    function handleLimitPayoutChange(limitPayoutFlag) {
      if (!limitPayoutFlag) {
        affiliateService.removePayoutCaps(vm.payoutSettingsObject, vm.payoutCaps);
      }
    }

    function toggleSetHours() {
      if (!vm.setPayoutHours) {
        vm.payoutSettingsObject.payoutHours = null;
        onPayoutHoursChange(vm.payoutSettingsObject.payoutHours);
      }
    }

    function onPayoutHoursChange(hoursOfOperation) {
      vm.payoutSettingsObject = vm.payoutSettingsObject || {};
      vm.payoutSettingsObject.payoutHours = hoursOfOperation;
      payoutSettingChange();
    }

    function inputChange() {
      vm.payoutSettingsObject.deDupeSetting.secondsFromLastCall = (vm.deDupeSettingTime.hours * 3600) + (vm.deDupeSettingTime.days * 86400);
      payoutSettingChange();
    }

    function toggleValueChanged(deDupeSettingsToggle) {
      vm.deDupeSettingsToggle = deDupeSettingsToggle;
      _toggleChange();
      payoutSettingChange();
    }

    function onRevShareRangeToggle(revShareRangeEnabled) {
      vm.payoutSettingsObject = vm.payoutSettingsObject || {};

      if (revShareRangeEnabled) {
        vm.payoutSettingsObject.revShareMinPayoutAmount = 0;
        vm.payoutSettingsObject.revShareMaxPayoutAmount = 0;
      } else {
        vm.payoutSettingsObject.revShareMinPayoutAmount = -1;
        vm.payoutSettingsObject.revShareMaxPayoutAmount = -1;
      }

      payoutSettingChange();
    }

    function _initSetHours() {
      if (vm.payoutSettingsObject?.payoutHours && !vm.setPayoutHours) {
        vm.setPayoutHours = true;
      }
    }

    function _setRevShareToggle(payoutSettings) {
      if (payoutSettings && payoutSettings.revSharePercentage &&
        (payoutSettings.revShareMinPayoutAmount && payoutSettings.revShareMinPayoutAmount >= 0)
        || (payoutSettings.revShareMaxPayoutAmount && payoutSettings.revShareMaxPayoutAmount >= 0)) {
        vm.revShareWithRange = true;
      } else {
        vm.revShareWithRange = false;
      }
    }

    function _sanitizePayout() {
      vm.payoutSettingsObject = vm.payoutSettingsObject || {};
      payoutService.sanitizePayout(vm.payoutSettingsObject);
      _setRevShareToggle(vm.payoutSettingsObject);
    }

    function _toggleChange() {
      vm.payoutSettingsObject.deDupeSetting = vm.payoutSettingsObject.deDupeSetting || {};
      switch (vm.deDupeSettingsToggle) {
      case -1:
        vm.payoutSettingsObject.deDupeSetting.secondsFromLastCall = -1;
        break;
      case 0:
        vm.payoutSettingsObject.deDupeSetting.secondsFromLastCall = 0;
        break;
      case 1:
        inputChange();
        break;
      }
    }

    function _setShowCaps() {
      vm.showCaps = false;
      vm.payoutSettingsObject = vm.payoutSettingsObject || {};
      if (_testCap(vm.payoutSettingsObject.allTimeCap)) { vm.showCaps = true; }
      if (_testCap(vm.payoutSettingsObject.monthlyCap)) { vm.showCaps = true; }
      if (_testCap(vm.payoutSettingsObject.dailyCap)) { vm.showCaps = true; }
      if (_testCap(vm.payoutSettingsObject.hourlyCap)) { vm.showCaps = true; }
      if (_testCap(vm.payoutSettingsObject.allTimeSumCap)) { vm.showCaps = true; }
      if (_testCap(vm.payoutSettingsObject.monthlySumCap)) { vm.showCaps = true; }
      if (_testCap(vm.payoutSettingsObject.dailySumCap)) { vm.showCaps = true; }
      if (_testCap(vm.payoutSettingsObject.hourlySumCap)) { vm.showCaps = true; }
      if (_testCap(vm.payoutSettingsObject.concurrencyCap)) { vm.showCaps = true; }
    }

    function _loadConversionSettings() {
      infoService.getConversionSettings(true)
        .then(function (response) {
          vm.conversionSettings = response.data;
        })
        .catch(utils.errorHandler);
    }

    function _loadTimeZones() {
      infoService.getTimeZones()
        .then(function (response) {
          vm.timeZones = response.data;
        });
    }

    function _testCap(cap) {
      return cap > -1;
    }


  }
})();
